var map = {
	"./": [
		64233,
		5769
	],
	"./bsc": [
		42484,
		2484
	],
	"./bsc.ts": [
		42484,
		2484
	],
	"./bscTestnet": [
		85600,
		5600
	],
	"./bscTestnet.ts": [
		85600,
		5600
	],
	"./goerli": [
		30893,
		893
	],
	"./goerli.ts": [
		30893,
		893
	],
	"./index": [
		64233,
		5769
	],
	"./index.ts": [
		64233,
		5769
	],
	"./polygonZkEVM": [
		83427,
		3427
	],
	"./polygonZkEVM.ts": [
		83427,
		3427
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 24615;
module.exports = webpackAsyncContext;